export const musicCollection_8200 = 
{
    "@type": "Context",
    "id": 8200,
    "title": "Rustig",
    "description": "05",
    "lastChanged": null,
    "changeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Style",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Style",
            "value": [
                {
                    "value": "Electronic",
                    "selected": true
                },
                {
                    "value": "Folk",
                    "selected": false
                },
                {
                    "value": "Lounge",
                    "selected": false
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": false
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1970,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1970,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 3,
            "maximum": 5,
            "step": 1,
            "lowerSelection": 3,
            "upperSelection": 4,
            "metadataDisplayMinimum": "3",
            "metadataDisplayMaximum": "5"
        }
    ],
    "defaultChangeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Style",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Style",
            "value": [
                {
                    "value": "Electronic",
                    "selected": true
                },
                {
                    "value": "Folk",
                    "selected": true
                },
                {
                    "value": "Lounge",
                    "selected": true
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 1970,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 1980,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "Region Popularity",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Region Popularity",
            "minimum": 3,
            "maximum": 5,
            "step": 1,
            "lowerSelection": 4,
            "upperSelection": 5,
            "metadataDisplayMinimum": "3",
            "metadataDisplayMaximum": "5"
        }
    ],
    "visible": true,
    "editable": false,
    "favourite": false,
    "selected": false,
    "mostPlayed": false,
    "defaultSelected": false
};